import React, { useEffect } from "react";
import { asyncConnect } from "../../../../resolvers";
import { NPKCatalogs } from "@smartdevis/server/src/domain";
import { downloadDrawing } from ".";
import { Spinner } from "@smartdevis/ui/src/Spinner";

const drawingCache: Record<string, NPKCatalogs.Drawing> = {};

export const NPKCatalogDrawing: React.FC<{ drawingId: string }> = asyncConnect({ stateResolvers: ["auth"] })(p => {

    const [drawingInfo, setDrawingInfo] = React.useState<NPKCatalogs.Drawing>()

    useEffect(() => {
        let isMounted = true;

        const fetchDrawing = async () => {
            if (drawingCache[p.drawingId]) {
                setDrawingInfo(drawingCache[p.drawingId]);
                return;
            }

            try {
                const data = await downloadDrawing(p.auth, p.drawingId);
                const drawing = data.value[0] as NPKCatalogs.Drawing;
                drawingCache[p.drawingId] = drawing;
                if (isMounted) {
                    setDrawingInfo(drawing);
                }
            } catch (err) {
                console.warn('[Error] loading drawingId: ',p.drawingId, err);
            }
        };

        fetchDrawing();

        return () => {
            isMounted = false;
        };
    }, [p.drawingId]);

    if (!drawingInfo) return <Spinner/>

    return <img src={`data:${drawingInfo.mimeType};base64,${drawingInfo.imgData}`} />

})